import type { Category } from "@/types/gallery";

export const categories: Category[] = [
  {
    id: "fashion",
    name: "时尚大片",
    description:
      "以时装造型与高级秀场质感为核心，展现模特在镜头前的强大气场与当代表达，是国模白露最具时尚张力的作品板块。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20fashion%20model%20in%20structured%20couture%20coat%20posing%20against%20a%20minimal%20stone%20wall%2C%20editorial%20fashion%20photography%2C%20soft%20directional%20daylight%2C%20neutral%20warm%20beige%20tones%2C%20cinematic%20color%20grading%2C%20high-end%20magazine%20aesthetic%2C%20wide%20composition&width=1600&height=900&seq=gmbl-cat-fashion&orientation=landscape",
  },
  {
    id: "portrait",
    name: "人像写真",
    description:
      "聚焦人物情绪与面部细节，强调自然光下的真实肌肤质感与温柔氛围，是写真爱好者最常回看的经典分类。",
    cover:
      "https://readdy.ai/api/search-image?query=Close-up%20elegant%20Chinese%20female%20portrait%20in%20soft%20ivory%20knitwear%20by%20a%20large%20window%2C%20natural%20window%20light%2C%20warm%20neutral%20tones%2C%20fine%20skin%20texture%2C%20editorial%20portrait%20photography%2C%20cinematic%20color%20grading%2C%20minimal%20quiet%20background%2C%20high-end%20magazine%20style&width=1600&height=900&seq=gmbl-cat-portrait&orientation=landscape",
  },
  {
    id: "outdoor",
    name: "户外旅拍",
    description:
      "在海岸、山林与城市之间行走拍摄，用开阔的环境光影衬托模特的身姿，营造自由而舒展的旅行叙事感。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20fashion%20model%20in%20flowing%20light%20dress%20standing%20on%20a%20sunlit%20coastal%20cliff%20at%20golden%20hour%2C%20travel%20portrait%20photography%2C%20warm%20amber%20tones%2C%20cinematic%20color%20grading%2C%20soft%20haze%2C%20wide%20airy%20composition%2C%20high-end%20editorial%20aesthetic&width=1600&height=900&seq=gmbl-cat-outdoor&orientation=landscape",
  },
  {
    id: "studio",
    name: "棚拍艺术",
    description:
      "以可控灯光与纯色背景构建雕塑感画面，通过光影层次突出模特的轮廓线条，呈现克制而高级的艺术表达。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20female%20model%20posing%20in%20a%20bright%20minimal%20photo%20studio%20with%20soft%20grey%20backdrop%2C%20controlled%20softbox%20lighting%2C%20clean%20neutral%20tones%2C%20sculptural%20body%20lines%2C%20editorial%20studio%20photography%2C%20high-end%20magazine%20aesthetic%2C%20minimal%20elegant%20composition&width=1600&height=900&seq=gmbl-cat-studio&orientation=landscape",
  },
  {
    id: "retro",
    name: "复古胶片",
    description:
      "模拟银盐胶片的颗粒与暖旧色调，还原旧时光的浪漫质感，为写真作品注入一份怀旧而细腻的情绪。",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20model%20in%20vintage%20tailored%20suit%20posing%20in%20a%20nostalgic%20old%20town%20alley%2C%20analog%20film%20photography%20look%2C%20warm%20faded%20tones%2C%20visible%20film%20grain%2C%20soft%20afternoon%20light%2C%20cinematic%20color%20grading%2C%20retro%20editorial%20aesthetic%2C%20wide%20composition&width=1600&height=900&seq=gmbl-cat-retro&orientation=landscape",
  },
];